import { type QueryHookOptions, useQuery } from "@apollo/client";
import { StreamEventProductsQuery } from "../graphql/queries";
import type {
  StreamEventProductsQueryType,
  StreamEventProductsQueryVariablesType,
} from "@/types/graphql/partner.generated";

export const useStreamEventProductsQuery = (
  options?: QueryHookOptions<
    StreamEventProductsQueryType,
    StreamEventProductsQueryVariablesType
  >
) =>
  useQuery<StreamEventProductsQueryType, StreamEventProductsQueryVariablesType>(
    StreamEventProductsQuery,
    options
  );
